import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { CHATS_ARQUIVADAS_DESIGN as D } from './ChatsArquivadas.design';

export default function ModalExcluirDivisao({ aberto, divisao, divisoes, onFechar, onConfirmar }) {
    const { t } = useTranslation('chat');
    const [moverPara, setMoverPara] = useState('');
    const [excluindo, setExcluindo] = useState(false);
    const [erro, setErro] = useState(null);

    const destinos = (divisoes || []).filter((d) => `${d._id}` !== `${divisao?._id}`);
    const temConversas = (divisao?.total || 0) > 0;

    useEffect(() => {
        if (!aberto) return;
        setMoverPara(destinos.length ? `${destinos[0]._id}` : '');
        setErro(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aberto, divisao]);

    if (!aberto || !divisao) return null;

    const handleConfirmar = async () => {
        if (temConversas && !moverPara) {
            setErro(t('archive.deleteDivision.errorNeedDestination', 'Crie outra divisão antes de excluir esta — as conversas precisam de destino'));
            return;
        }

        setExcluindo(true);
        setErro(null);
        try {
            await onConfirmar(`${divisao._id}`, temConversas ? moverPara : null);
            onFechar();
        } catch (error) {
            setErro(error?.mensagem || t('archive.deleteDivision.errorGeneric', 'Não foi possível excluir a divisão'));
        } finally {
            setExcluindo(false);
        }
    };

    return (
        <div className={D.modal.backdrop} onClick={onFechar}>
            <div className={D.modal.container} onClick={(e) => e.stopPropagation()}>
                <div className={D.modal.header}>
                    <div className="w-9 h-9 rounded-xl bg-red-50 flex items-center justify-center">
                        <Iconify icon="eva:trash-2-outline" width={18} className="text-red-600" />
                    </div>
                    <div>
                        <p className={D.modal.title}>
                            {t('archive.deleteDivision.title', 'Excluir “{{name}}”', { name: divisao.nome })}
                        </p>
                        <p className={D.modal.subtitle}>
                            {temConversas
                                ? t('archive.deleteDivision.subtitleHasChats', '{{count}} conversa(s) precisam ir para outra divisão', { count: divisao.total })
                                : t('archive.deleteDivision.subtitleEmpty', 'Esta divisão está vazia')}
                        </p>
                    </div>
                </div>

                <div className={D.modal.body}>
                    {erro && (
                        <div className={D.modal.error}>
                            <Iconify icon="eva:alert-circle-outline" width={14} />
                            {erro}
                        </div>
                    )}

                    {temConversas && (
                        <div>
                            <label className={D.modal.label}>{t('archive.deleteDivision.moveTo', 'Mover conversas para')}</label>
                            <select
                                value={moverPara}
                                onChange={(e) => setMoverPara(e.target.value)}
                                className={D.modal.input}
                            >
                                {!destinos.length && (
                                    <option value="">{t('archive.deleteDivision.noOtherDivisions', 'Nenhuma outra divisão disponível')}</option>
                                )}
                                {destinos.map((destino) => (
                                    <option key={`${destino._id}`} value={`${destino._id}`}>
                                        {destino.nome}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                </div>

                <div className={D.modal.footer}>
                    <button type="button" className={D.modal.cancel} onClick={onFechar}>
                        {t('archive.deleteDivision.cancel', 'Cancelar')}
                    </button>
                    <button
                        type="button"
                        className={D.modal.danger}
                        onClick={handleConfirmar}
                        disabled={excluindo}
                    >
                        {excluindo ? t('archive.deleteDivision.deleting', 'Excluindo...') : t('archive.deleteDivision.confirm', 'Excluir divisão')}
                    </button>
                </div>
            </div>
        </div>
    );
}
